import { defineStore } from "pinia";

export const useListFilters = defineStore("listFilters", {
  persist: true,
  state: () => ({
    doctorFilter: "" as string,
    patientFilter: "" as string,
    payoutFilter: "" as string,
    registerRequestFilter: "" as string,
    rows: 5 as number,
  }),
  actions: {
    setDoctorFilter(query: string) {
      this.doctorFilter = query;
    },
    clearDoctorFilter() {
      this.doctorFilter = "";
    },
    setPatientFilter(query: string) {
      this.patientFilter = query;
    },
    clearPatientFilter() {
      this.patientFilter = "";
    },
    setPayoutFilter(query: string) {
      this.payoutFilter = query;
    },
    clearPayoutFilter() {
      this.payoutFilter = "";
    },
    setRegisterRequestFilter(query: string) {
      this.registerRequestFilter = query;
    },
    clearRegisterRequestFilter() {
      this.registerRequestFilter = "";
    },
    setRows(rows: number) {
      this.rows = rows;
    },
  },
});
